var OrgTypes = {
	ALL_STUDENTS: "all-students",
	ALL_STUDENT_LISTS: "all-student-lists",
	ALL_SCHOOL_ORGS: "all-school-orgs",

	STUDENT_LIST: "student-list",
	SUBGROUP: "subgroup",
	SCHOOL_ORG: "school-org",
	DISTRICT_ORG: "district-org",

	isEveryoneIdentifier: (identifier) => {
		return OrgTypes.EVERYONE_TYPES.includes(OrgTypes.fromIdentifier(identifier).type);
	},
	isStudentListIdentifier: (identifier) => {
		return OrgTypes.fromIdentifier(identifier).type == OrgTypes.STUDENT_LIST;
	},
	isSchoolOrgIdentifier: (identifier) => {
		return OrgTypes.fromIdentifier(identifier).type == OrgTypes.SCHOOL_ORG;
	},
	isDistrictOrgIdentifier: (identifier) => {
		return OrgTypes.fromIdentifier(identifier).type == OrgTypes.DISTRICT_ORG;
	},

	toIdentifier: ({ type, key }) => {
		if (key) {
			return type + ":" + key;
		} else {
			return type;
		}
	},

	fromIdentifier: (identifier) => {
		if (!identifier) {
			throw "Missing identifier in OrgTypes";
		}
		var parts = identifier.split(":");
		if ((parts[0] == OrgTypes.STUDENT_LIST) || (parts[0] == OrgTypes.SCHOOL_ORG)) {
			return { type: parts[0], key: parseInt(parts[1]) };
		} else {
			return { type: parts[0], key: parts[1] };			
		}
	}
}

OrgTypes.EVERYONE_TYPES = [
	OrgTypes.ALL_STUDENTS,
	OrgTypes.ALL_STUDENT_LISTS,
	OrgTypes.ALL_SCHOOL_ORGS,
]

// Note: This is (currently) the same as just OrgTypes.ALL_STUDENTS
// But in case it changes, I'd rather use this as the default in other places
OrgTypes.ALL_STUDENTS_IDENTIFIER = OrgTypes.toIdentifier({ type: OrgTypes.ALL_STUDENTS });
OrgTypes.ALL_STUDENT_LISTS_IDENTIFIER = OrgTypes.toIdentifier({ type: OrgTypes.ALL_STUDENT_LISTS });
OrgTypes.ALL_SCHOOL_ORGS_IDENTIFIER = OrgTypes.toIdentifier({ type: OrgTypes.ALL_SCHOOL_ORGS });

module.exports = OrgTypes;



// WEBPACK FOOTER //
// ./modules/lib/academic/OrgTypes.js